import React, { useState, useEffect, useRef } from 'react';
import '../../assets/Styles/DispatchCSS/sidebarCSS.css';
import {Icon} from '@iconify/react';
import { useSelector } from "react-redux";
import ModuleSecurity from '../../utils/helpers/ModuleSecurity';
import APICom from "../../utils/helpers/APICom.js";
import { useDispatch } from 'react-redux';
import CommonFunctions from '../../utils/helpers/CommonFunctions';
import { SetCombineData } from '../../features/common/combinedataSlice';

const MenuSideBar = (props = {}) => {
    const {GlobalASCSData} = useSelector((store) => store.combinedata);
    const xCancelSourceForGrid = useRef(null);
    const dispatch = useDispatch();

    const [InputHTML, setInputHTML] = useState([]);
    const [SignOut, setSignOutHTML] = useState([]);
    const [listofTripActionsHTML, setListofTripActionsHTML] = useState([]);
    const [listofCallCenterActionsHTML, setListofCallCenterActionsHTML] = useState([]);
    const [listofDriverActionsHTML, setListofDriverActionsHTML] = useState([]);
    const [listofBrokerActionsHTML, setListofBrokerActionsHTML] = useState([]);
    const [listofRouteActionsHTML, setListofRouteActionsHTML] = useState([]);
    const [listOfAdminSetupActionsHTML, setListOfAdminSetupActionsHTML] = useState([]);
    const [listOfReportsHTML , setListOfReportsHTML] = useState([]);
    const [listofMTDiagnosticHTML, setListofMTDiagnosticHTML] = useState([]);
    const [listofStandingOrderHTML, setListofStandingOrderHTML] = useState([]);
    const [listofCompletedQueueHTML, setListofCompletedQueueHTML] = useState([]);
    const [menuResizeGroupBtnHTML, setMenuResizeGroupBtnHTML] = useState(<Icon icon={'bx:collapse-alt'} style={{color:"orange", cursor:"pointer"}}/>);
    const [tripActionsArrowHTML, setTripActionsArrowHTML] = useState(<Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>);
    const [callCenterActionsArrowHTML, setCallCenterActionsArrowHTML] = useState(<Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>);
    const [driverActionsArrowHTML, setDriverActionsArrowHTML] = useState(<Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>);
    const [brokerActionsArrowHTML, setBrokerActionsArrowHTML] = useState(<Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>);
    const [routeActionsArrowHTML, setRouteActionsArrowHTML] = useState(<Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>);
    const [adminSetupActionsArrowHTML, setAdminSetupActionsArrowHTML] = useState(<Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>);
    const [reportsArrowHTML, setReportsArrowHTML] = useState(<Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color: "orange"}} />);
    const [mtDiagnosticArrowHTML, setMTDiagnosticArrowHTML] = useState(<Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>);
    const [standingOrderArrowHTML, setStandingOrderArrowHTML] = useState(<Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>);
    const [completedQueueArrowHTML, setCompletedQueueArrowHTML] = useState(<Icon icon={'bx:chevron-down'} className='float-end d-inline-flex m-auto' style={{color:"orange"}}/>);
    const [menuReloadCombinedDataCacheBtnHTML, setMenuReloadCombinedDataCacheBtnHTML] = useState(<Icon icon={'streamline:arrow-reload-horizontal-2-solid'} style={{color:"green", cursor:"pointer"}}/>);
    
    const menuHeaderDetails = useRef([
        {btnName: 'input', HTMLSetter: setInputHTML},
        {btnName: 'signOut', HTMLSetter: setSignOutHTML},
        {btnName: 'CallCenter', HTMLSetter: setListofCallCenterActionsHTML, names:["Trip Reservation", "Trip Edit", "Copy Ride"]},
        {btnName: 'TripActions', HTMLSetter: setListofTripActionsHTML, names:["Dispatch Actions", "Agile Dispatch", "Cancel", "Activate", "Trip History", "Trip Information"]},
        {btnName: 'DriverActions', HTMLSetter: setListofDriverActionsHTML, names:["Driver Controls", "Vehicle Tracking", "Callback Counter"]},
        {btnName: 'BrokerActions', HTMLSetter: setListofBrokerActionsHTML, names:["Broker Actions"]},
        {btnName: 'RouteActions', HTMLSetter: setListofRouteActionsHTML, names:["Standing Routes", "RBSProcess", "Grouping Actions", "Clustering Actions", "Route Restrictions", "Manifest Actions","Daily OTP Plot","Manifest Settings" ]},
        {btnName: 'AdminActions', HTMLSetter: setListOfAdminSetupActionsHTML, names:["Zone Speed Multiplier"]},
        {btnName: 'ReportsActions', HTMLSetter: setListOfReportsHTML, names:["Trips Dashboard","Fixbus Dashboard", "Paratransit Dashboard", "AI Reporting"]},
        {btnName: 'MTDiagnostic', HTMLSetter: setListofMTDiagnosticHTML, names:["MT Diagnostic"]},
        {btnName: 'StandingOrder', HTMLSetter: setListofStandingOrderHTML, names:["Trip Reservation", "Trip Edit", "Cancel", "Show Multi-Sch", "Send Email", "Agent Notes", "Trip History"]},
        {btnName: 'CompletedQueue', HTMLSetter: setListofCompletedQueueHTML, names:["Copy Ride", "Trip History", "Driver Controls", "Agent Notes", "Add Extra Info"]},
    ]);
    
    const isReloadCombinedDataCachedAPICallInProgress = useRef(false);
    const tripActionsRef = useRef(null);
    const callCenterActionsRef = useRef(null);
    const driverActionsRef = useRef(null);
    const brokerActionsRef = useRef(null);
    const routeActionsRef = useRef(null);
    const adminSetupActionsRef = useRef(null);
    const reportsActionsRef = useRef(null);
    const mtDiagnosticRef = useRef(null);
    const standingOrderRef = useRef(null);
    const completedQueueRef = useRef(null);

    const sidebarWrapper = useRef(null);
    const reSizeBtnIconRef = useRef(null);
    const menuTracker = useRef(false);
    const actionRefs = useRef([{
        callcenter: { ref: callCenterActionsRef, setState: setCallCenterActionsArrowHTML },
        trip: { ref: tripActionsRef, setState: setTripActionsArrowHTML },
        driver: { ref: driverActionsRef, setState: setDriverActionsArrowHTML },
        broker: { ref: brokerActionsRef, setState: setBrokerActionsArrowHTML },
        route: { ref: routeActionsRef, setState: setRouteActionsArrowHTML },
        Admin: { ref: adminSetupActionsRef, setState: setAdminSetupActionsArrowHTML },
        Reports: { ref: reportsActionsRef, setState: setReportsArrowHTML },
        mtdiagnostic: { ref: mtDiagnosticRef, setState: setMTDiagnosticArrowHTML },
        standingOrder: { ref: standingOrderRef, setState: setStandingOrderArrowHTML },
        completedQueue: {ref: completedQueueRef, setState: setCompletedQueueArrowHTML }
    }, [
        {ref : tripActionsRef, setter: setTripActionsArrowHTML},
        {ref : callCenterActionsRef, setter: setCallCenterActionsArrowHTML},
        {ref : driverActionsRef, setter: setDriverActionsArrowHTML},
        {ref : brokerActionsRef, setter: setBrokerActionsArrowHTML},
        {ref : routeActionsRef, setter: setRouteActionsArrowHTML},
        {ref : adminSetupActionsRef, setter: setAdminSetupActionsArrowHTML},
        {ref : reportsActionsRef, setter: setReportsArrowHTML},
        {ref : mtDiagnosticRef, setter: setMTDiagnosticArrowHTML},
        {ref : standingOrderRef, setter: setStandingOrderArrowHTML},
        {ref : completedQueueRef, setter: setCompletedQueueArrowHTML}
    ]]);

    const { isLoggedIn, loginData } = useSelector((store) => store.login);

    const handleClosedSidebar = ()=>{
        try{
            if(menuTracker.current)
            {
                props.navbarTracker.classList.remove('navBarStyle');
                let gridContainer = document.getElementById(props.options.GridName+"_container");
                let mapContainer = document.getElementById(props.options.GridName +'_mapContainer');
                let clusterContainer = document.getElementById("clusterTableGrid_container");
                if(document.getElementById(props.options.GridName+'_mapViewBtn').textContent.toUpperCase() === "MAP")
                {
                    gridContainer.classList.remove('gridClosedMapStyle');
                    gridContainer.classList.remove('gridOpenMapStyle');
                }
                else
                {
                    gridContainer.classList.remove('gridOpenMapStyle');
                    mapContainer.classList.remove('mapOpenStyle');
                    clusterContainer.classList.remove('mapOpenStyle');
                }
            }
        }
        catch(err){console.log(err);}
        
    };

    const handleSidebarToggle = () =>{
        props.setMenuSidebarToggle(prevCheck => !prevCheck);
        menuTracker.current = true;
        props.SetSidebarStatus(false);
        handleClosedSidebar(); 
    }

    const handleCollapseSideBar = (e)=>{
        try{
            
            let btnHTML = "";
            let arrowHTML = "";

            reSizeBtnIconRef.current.title = (reSizeBtnIconRef.current.title.toLowerCase().includes("collapse") ? "Expand Sidebar Groups" : "Collapse Sidebar Groups");
            btnHTML = function(){
                return(
                    <Icon icon={`${reSizeBtnIconRef.current.title.toLowerCase().includes("expand") ? 'bx:expand-alt' : 'bx:collapse-alt'}`} 
                        style={{color:"orange", cursor:"pointer"}}
                    />
                );
            };
            arrowHTML = function(){
                return(
                    <Icon icon={`${reSizeBtnIconRef.current.title.toLowerCase().includes("expand") ? 'bx:chevron-up' : 'bx:chevron-down'}`} 
                        className='float-end d-inline-flex m-auto' style={{color:"orange"}}
                    />
                );
            };
            actionRefs.current[1].forEach(item => {
                if(item.ref.current)
                {
                    item.ref.current.classList = `nav-list my-0 ${reSizeBtnIconRef.current.title.toLowerCase().includes("expand") ? 'collapse' : 'expand'}`;
                    item.setter(arrowHTML);
                }
            });
            setMenuResizeGroupBtnHTML(btnHTML);
            
        }
        catch(err){console.log(err);}
    };

    const getCombinedDataAPIURLFromSettings = () => {
        let combinedDataAPIURL = GlobalASCSData.find(item => item.SubTitle === "MRMS2CombinedAPIURL")?.value;
        try {
            if(combinedDataAPIURL !== undefined && combinedDataAPIURL !== null && combinedDataAPIURL !== ""){
                let lastCharacter = combinedDataAPIURL[combinedDataAPIURL.length - 1];
                if(lastCharacter !== undefined){
                    if(lastCharacter === '/'){
                    combinedDataAPIURL += "CombinedData/GenerateCombinedData";
                    }
                    else{
                    combinedDataAPIURL += "/CombinedData/GenerateCombinedData";
                    }
                }
            }
        } catch (error) {
            console.log(error);
            return combinedDataAPIURL;
        }
        return combinedDataAPIURL;
    }
    
    const setReloadCombinedDataAPIIconColor = (response = "default") => {
        let iconColor = <Icon icon={'streamline:arrow-reload-horizontal-2-solid'} style={{color:"green", cursor:"pointer"}}/>
        try {

            if(response == false){
                iconColor = function(){
                    return(
                        <Icon icon={'streamline:arrow-reload-horizontal-2-solid'} style={{color:"darkgrey", cursor:"pointer"}}/>
                    );
                };
                setMenuReloadCombinedDataCacheBtnHTML(iconColor);
            }
            else if (response == true){
                setMenuReloadCombinedDataCacheBtnHTML(iconColor);
            }
            else if (response == "NoURL"){
                iconColor = <Icon icon={'streamline:arrow-reload-horizontal-2-solid'} style={{color:"darkred", cursor:"pointer"}}/>
                setMenuReloadCombinedDataCacheBtnHTML(iconColor);
            }
            else{
                iconColor = <Icon icon={'streamline:arrow-reload-horizontal-2-solid'} style={{color:"darkgrey", cursor:"pointer"}}/>
                setMenuReloadCombinedDataCacheBtnHTML(iconColor);
            }
        } catch (error) {
            iconColor =  <Icon icon={'streamline:arrow-reload-horizontal-2-solid'} style={{color:"darkred", cursor:"pointer"}}/>
            setMenuReloadCombinedDataCacheBtnHTML(iconColor);
        }
    }

    const handleReloadCombinedDataAPI = async(e) => {
        try {
            if(isReloadCombinedDataCachedAPICallInProgress.current == true){
                return;
            }
            setReloadCombinedDataAPIIconColor("default");
            //let combinedDataAPIURL = getCombinedDataAPIURLFromSettings();
        
            xCancelSourceForGrid.current = APICom.GenerateSource();
            isReloadCombinedDataCachedAPICallInProgress.current = true;
            let response = await APICom.fetchData("AspDotNetCoreURL","CombinedData/GenerateCombinedData", "get", 
                {'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'mode': 'no-cors'}, "", xCancelSourceForGrid.current
            );
            if(response !== undefined && response){
                isReloadCombinedDataCachedAPICallInProgress.current = false;
                if(response.data === true){
                    setReloadCombinedDataAPIIconColor(response.data);
                    const responseCombinedData = await CommonFunctions.PopulateCombineData();
                    dispatch(SetCombineData({data: responseCombinedData["FamilyData"], name:"FamilyData"}));
                    dispatch(SetCombineData({data: responseCombinedData["AffiliateData"], name:"AffiliateData"}));
                    dispatch(SetCombineData({data: responseCombinedData["BrokerServingAffiliatesData"], name:"BrokerServingAffiliatesData"}));
                    dispatch(SetCombineData({data: responseCombinedData["FundingSourceData"], name:"FundingSourceData"}));
                    dispatch(SetCombineData({data: responseCombinedData["ASCSSettingData"], name:"ASCSSettingData"}));
                    dispatch(SetCombineData({data: responseCombinedData["CancelReasonData"], name:"CancelReasonData"}));
                    dispatch(SetCombineData({data: responseCombinedData["NoShowReasonData"], name:"NoShowReasonData"}));
                    dispatch(SetCombineData({data: responseCombinedData["DispatchDriverData"], name:"DispatchDriverData"}));
                    dispatch(SetCombineData({data: responseCombinedData["DispatchVehicleData"], name:"DispatchVehicleData"}));
                    dispatch(SetCombineData({data: responseCombinedData["BrokerCancelReasonData"], name:"BrokerCancelReasonData"}));
                    dispatch(SetCombineData({data: responseCombinedData["VehicleInfoData"], name:"VehicleInfoData"}));
                    dispatch(SetCombineData({data: responseCombinedData["AttributeData"].Table, name:"AttributeData"}));
                    dispatch(SetCombineData({data: responseCombinedData["GlobalASCSData"], name:"GlobalASCSData"}));
                    dispatch(SetCombineData({data: responseCombinedData["ZoneVerticesData"], name:"ZoneVerticesData"}));
                    dispatch(SetCombineData({data: responseCombinedData["VirtualStopsData"], name:"VirtualStopsData"}));
                    dispatch(SetCombineData({data: responseCombinedData["ClassOfServiceData"], name:"ClassOfServiceData"}));
                    dispatch(SetCombineData({data: responseCombinedData["PaymentTypesData"], name:"PaymentTypesData"}));
                    dispatch(SetCombineData({data: responseCombinedData["RCZZoneVerticesData"], name:"RCZZoneVerticesData"}));
                    dispatch(SetCombineData({data: responseCombinedData["ZoneSpeedMultiplier"], name:"ZoneSpeedMultiplier"}));
                    dispatch(SetCombineData({data: responseCombinedData["VehicleTypesPerAffiliateData"], name:"VehicleTypesPerAffiliateData"}));
                    dispatch(SetCombineData({data: responseCombinedData["OARAAlarmStatusData"], name:"OARAAlarmStatusData"}));
                }
                else
                {
                    setReloadCombinedDataAPIIconColor(false);
                }
            }
        } catch (error) {
            console.log(error);
            isReloadCombinedDataCachedAPICallInProgress.current = false;
        }
    }

    const getArrowIcon = (isExpanded) => {
        return(
            <Icon 
                icon={isExpanded ?  'bx:chevron-down':'bx:chevron-up'} 
                className='float-end d-inline-flex m-auto' 
                style={{ color: "orange" }} 
            />
        );
    };

    const handleReSizeMenu = (type) => {
        try{
            const action = actionRefs.current[0][type];
            if(!action) return; //Exit for invalid type

            const {ref, setState} = action;

            if(!ref.current) return;

            const isCollapsed = ref.current.classList.contains("collapse");
            ref.current.classList = `nav-list my-0 ${isCollapsed ? "expand" : "collapse"}`;
            setState(getArrowIcon(isCollapsed));
        }
        catch(err){console.log(err);}
    };

    const handleBtnFuncMapping = () => {
        try{
            if(props.btnFuncs.length > 0)
            {
                // console.log(props.btnFuncs);
                let dynamicElements = "";
                let inputSearch = "";
                let logoutHTML = "";
                inputSearch = props.btnFuncs.map(function(item, index){
                    if(item.btnName === "input"){
                        return(
                            <li key={index} className='my-0'>
                                <input  className='bg-white h-100 rounded-0 text-center p-0 px-1 text-dark' onKeyUp={item.btnFunc} type='text' placeholder='Search...'/>
                            </li>
                        );
                    }
                });
                logoutHTML= props.btnFuncs.map(function(item, index){
                    if(item.btnName === "Sign Out")
                    {
                        return(
                            <li key={index} className='my-0'>
                                <a href={"#"+item.btnName} title={item.title} onClick={item.btnFunc}>
                                    <Icon className='text-danger' icon={item.icon}/>
                                    <span className="links_name fw-bold text-danger">{item.btnName}</span>
                                </a>
                                <span className="tooltip">{item.btnName}</span>
                            </li>
                        );
                    }
                });
                setSignOutHTML(logoutHTML);
                setInputHTML(inputSearch);
                dynamicElements = props.btnFuncs
                .filter(element =>{ 
                    if(!element.tag){
                        return true;
                    }
                    else if(ModuleSecurity.CheckModuleSecurityByTag(element.tag) === false){
                        return false;
                    }
                    else{
                        return true;
                    }
                })
                .map(function(item, index) {
                    if(item.btnName !== "input" && props.options.GridName !== 'standingOrder' && props.options.GridName !== 'completedQueue' && ["Trip Reservation", "Trip Edit", "Copy Ride"].includes(item.btnName))
                    {
                        return(
                            <li key={index} className='sidebarOptionClass mx-2 my-0' style={{fontSize:"smaller"}}>
                                <a href={"#"+item.btnName} title={item.title} onClick={item.btnFunc}>
                                    <Icon icon={item.icon}/>
                                    <span className="links_name" style={{fontSize:"small"}}>{item.btnName}</span>
                                </a>
                                <span className="tooltip">{item.btnName}</span>
                            </li>
                        );
                    }
                    
                }).filter(Boolean);

                setListofCallCenterActionsHTML(dynamicElements)

                dynamicElements = props.btnFuncs
                .filter(element =>{ 
                    if(!element.tag){
                        return true;
                    }
                    else if(ModuleSecurity.CheckModuleSecurityByTag(element.tag) === false){
                        return false;
                    }
                    else{
                        return true;
                    }
                })
                .map(function(item, index) {
                    if(item.btnName !== "input" && props.options.GridName !== 'standingOrder' && props.options.GridName !== 'completedQueue' && ["Dispatch Actions", "Agile Dispatch", "Cancel", "Activate", "Trip History", "Trip Information"].includes(item.btnName))
                    {
                        return(
                            <li key={index} className='sidebarOptionClass mx-2 my-0' style={{fontSize:"smaller"}}>
                                <a href={"#"+item.btnName} title={item.title} onClick={item.btnFunc}>
                                    <Icon icon={item.icon}/>
                                    <span className="links_name" style={{fontSize:"small"}}>{item.btnName}</span>
                                </a>
                                <span className="tooltip">{item.btnName}</span>
                            </li>
                        );
                    }
                    
                }).filter(Boolean);
                
                setListofTripActionsHTML(dynamicElements);
    
                dynamicElements = props.btnFuncs
                .filter(element =>{ 
                    if(!element.tag){
                        return true;
                    }
                    else if(ModuleSecurity.CheckModuleSecurityByTag(element.tag) === false){
                        return false;
                    }
                    else{
                        return true;
                    }
                })
                .map(function(item, index) {
                    if(item.btnName !== "input" && props.options.GridName !== 'standingOrder' && props.options.GridName !== 'completedQueue' && ["Driver Controls", "Vehicle Tracking", "Callback Counter"].includes(item.btnName))
                    {
                        return(
                            <li key={index} className='sidebarOptionClass mx-2 my-0' style={{fontSize:"smaller"}}>
                                <a href={"#"+item.btnName} title={item.title} onClick={item.btnFunc}>
                                    <Icon icon={item.icon}/>
                                    <span className="links_name" style={{fontSize:"small"}}>{item.btnName}</span>
                                </a>
                                <span className="tooltip">{item.btnName}</span>
                            </li>
                        );
                    }
                    
                }).filter(Boolean);
    
                setListofDriverActionsHTML(dynamicElements);
                
                dynamicElements = props.btnFuncs
                .filter(element =>{ 
                    if(!element.tag){
                        return true;
                    }
                    else if(ModuleSecurity.CheckModuleSecurityByTag(element.tag) === false){
                        return false;
                    }
                    else{
                        return true;
                    }
                })
                .map(function(item, index) {
                    if(item.btnName !== "input" && ["Broker Actions"].includes(item.btnName))
                    {
                        return(
                            <li key={index} className='sidebarOptionClass mx-2 my-0' style={{fontSize:"smaller"}}>
                                <a href={"#"+item.btnName} title={item.title} onClick={item.btnFunc}>
                                    <Icon icon={item.icon}/>
                                    <span className="links_name" style={{fontSize:"small"}}>{item.btnName}</span>
                                </a>
                                <span className="tooltip">{item.btnName}</span>
                            </li>
                        );
                    }
                    
                }).filter(Boolean);
    
                setListofBrokerActionsHTML(dynamicElements);
                dynamicElements = props.btnFuncs
                .filter(element =>{ 
                    if(!element.tag){
                        return true;
                    }
                    else if(ModuleSecurity.CheckModuleSecurityByTag(element.tag) === false){
                        return false;
                    }
                    else{
                        return true;
                    }
                })
                .map(function(item, index) {
                    if(item.btnName !== "input" && ["Standing Routes", "RBSProcess", "Grouping Actions", 
                        "Clustering Actions", "Route Restrictions", "Manifest Actions","Daily OTP Plot","Manifest Settings" ].includes(item.btnName))
                    {
                        return(
                            <li key={index} className='sidebarOptionClass mx-2 my-0 py-0' style={{fontSize:"smaller"}}>
                                <a href={"#"+item.btnName} title={item.title} onClick={item.btnFunc}>
                                    <Icon icon={item.icon}/>
                                    <span className="links_name" style={{fontSize:"small"}}>{item.btnName}</span>
                                </a>
                                <span className="tooltip">{item.btnName}</span>
                            </li>
                        );
                    }
                    
                }).filter(Boolean);
    
                setListofRouteActionsHTML(dynamicElements);
                
                dynamicElements = props.btnFuncs
                    .filter(element => {
                        if (!element.tag) {
                            return true;
                        } else if (ModuleSecurity.CheckModuleSecurityByTag(element.tag) === false) {
                            return false;
                        } else {
                            return true;
                        }
                    })
                    .map((item, index) => {
                        if (item.btnName !== "input" && ["Trips Dashboard", "Paratransit Dashboard", "AI Reporting"].includes(item.btnName)) {
                            return (
                                <li key={index} className='sidebarOptionClass mx-2 my-0' style={{fontSize: "smaller"}}>
                                    <a href={"#"+item.btnName} title={item.title} onClick={item.btnFunc}>
                                        <Icon icon={item.icon}/>
                                        <span className="links_name" style={{fontSize: "small"}}>{item.btnName}</span>
                                    </a>
                                    <span className="tooltip">{item.btnName}</span>
                                </li>
                            );
                        }
                    })
                    .filter(Boolean);  // removes undefined elements

                setListOfReportsHTML(dynamicElements);

                dynamicElements = props.btnFuncs
                .filter(element =>{
                    if(!element.tag){
                        return true;
                    }
                    else if(ModuleSecurity.CheckModuleSecurityByTag(element.tag) === false){
                        return false;
                    }
                    else{
                        return true;
                    }
                })
                .map(function(item, index) {
                    if(item.btnName !== "input" && ["Zone Speed Multiplier"].includes(item.btnName))
                    {
                        return(
                            <li key={index} className='sidebarOptionClass mx-2 my-0' style={{fontSize:"smaller"}}>
                                <a href={"#"+item.btnName} title={item.title} onClick={item.btnFunc}>
                                    <Icon icon={item.icon}/>
                                    <span className="links_name" style={{fontSize:"small"}}>{item.btnName}</span>
                                </a>
                                <span className="tooltip">{item.btnName}</span>
                            </li>
                        );
                    }

                }).filter(Boolean);

                setListOfAdminSetupActionsHTML(dynamicElements);

                dynamicElements = props.btnFuncs
                .filter(element =>{ 
                    if(!element.tag){
                        return true;
                    }
                    else if(ModuleSecurity.CheckModuleSecurityByTag(element.tag) === false){
                        return false;
                    }
                    else{
                        return true;
                    }
                })
                .map(function(item, index) {
                    if(item.btnName !== "input" && ["MT Diagnostic"].includes(item.btnName))
                    {
                        return(
                            <li key={index} className='sidebarOptionClass mx-2 my-0 py-0' style={{fontSize:"smaller"}}>
                                <a href={"#"+item.btnName} title={item.title} onClick={item.btnFunc}>
                                    <Icon icon={item.icon}/>
                                    <span className="links_name" style={{fontSize:"small"}}>{item.btnName}</span>
                                </a>
                                <span className="tooltip">{item.btnName}</span>
                            </li>
                        );
                    }
                    
                }).filter(Boolean);
    
                setListofMTDiagnosticHTML(dynamicElements);

                dynamicElements = props.btnFuncs
                .filter(element =>{ 
                    if(!element.tag){
                        return true;
                    }
                    else if(ModuleSecurity.CheckModuleSecurityByTag(element.tag) === false){
                        return false;
                    }
                    else{
                        return true;
                    }
                })
                .map(function(item, index) {
                    if(item.btnName !== "input" && props.options.GridName === 'standingOrder' && ["Trip Reservation", "Trip Edit", "Cancel", "Show Multi-Sch", "Send Email", "Agent Notes", "Trip History", "Trip Information"].includes(item.btnName))
                    {
                        return(
                            <li key={index} className='sidebarOptionClass mx-2 my-0 py-0' style={{fontSize:"smaller"}}>
                                <a href={"#"+item.btnName} title={item.title} onClick={item.btnFunc}>
                                    <Icon icon={item.icon}/>
                                    <span className="links_name" style={{fontSize:"small"}}>{item.btnName}</span>
                                </a>
                                <span className="tooltip">{item.btnName}</span>
                            </li>
                        );
                    }
                    
                }).filter(Boolean);
    
                setListofStandingOrderHTML(dynamicElements);

                dynamicElements = props.btnFuncs
                .filter(element =>{ 
                    if(!element.tag){
                        return true;
                    }
                    else if(ModuleSecurity.CheckModuleSecurityByTag(element.tag) === false){
                        return false;
                    }
                    else{
                        return true;
                    }
                })
                .map(function(item, index) {
                    if(item.btnName !== "input" && props.options.GridName === 'completedQueue' && ["Copy Ride", "Trip History", "Driver Controls", "Agent Notes", "Add Extra Info"].includes(item.btnName))
                    {
                        return(
                            <li key={index} className='sidebarOptionClass mx-2 my-0 py-0' style={{fontSize:"smaller"}}>
                                <a href={"#"+item.btnName} title={item.title} onClick={item.btnFunc}>
                                    <Icon icon={item.icon}/>
                                    <span className="links_name" style={{fontSize:"small"}}>{item.btnName}</span>
                                </a>
                                <span className="tooltip">{item.btnName}</span>
                            </li>
                        );
                    }
                    
                }).filter(Boolean);
    
                setListofCompletedQueueHTML(dynamicElements);
            }
            else
            {
                setListofTripActionsHTML("");
                setListofCallCenterActionsHTML("");
                setListofDriverActionsHTML("");
                setListofBrokerActionsHTML("");
                setListofRouteActionsHTML("");
                setListOfAdminSetupActionsHTML("");
                setListOfReportsHTML("");
                setListofMTDiagnosticHTML("");
                setListofStandingOrderHTML("");
                setListofCompletedQueueHTML("");
            }
        }
        catch(err){console.log(err);}
    };

    useEffect(()=> {
        try{
            
            handleBtnFuncMapping();
            // function handleClickOutsideSidebar(event){
            //     // if (sidebarWrapper.current && !sidebarWrapper.current.contains(event.target))
            //     // {
            //     //     handleSidebarToggle();
            //     // }
            // };
    
            // document.addEventListener("mousedown", handleClickOutsideSidebar);
            // return() => {
            //     document.removeEventListener("mousedown", handleClickOutsideSidebar);
            // };
        }
        catch(err){console.log(err);}
        
    },[sidebarWrapper]);

    useEffect(()=> { //fix to btn func not being updated with open menu when affiliate changes
        try{
            handleBtnFuncMapping();
        }
        catch(err){console.log(err);}
    }, [JSON.stringify(props.btnFuncs)]);
    
    return (
        
        <nav ref={sidebarWrapper} className="sidebar open prevent-select" id="sidebar">
            <div className="logo-details">
                <div className="logo_name">Menu</div>
                <span ref={reSizeBtnIconRef} className='m-1 rounded' title={"Collapse Sidebar Groups"} onClick={handleCollapseSideBar}>
                    {menuResizeGroupBtnHTML}
                </span>
                <span className='m-1' title={"Reload Cached Data"} onClick={handleReloadCombinedDataAPI}>
                    {menuReloadCombinedDataCacheBtnHTML}
                </span>
                <Icon icon='bx:menu-alt-right' onClick={handleSidebarToggle} style={{color:"gray"}} id="btnClose"/>
            </div>
            <div className="text-light w-100 border border-light mt-2"  ><p className='overflow-hidden text-nowrap font-weight-light text-center small px-1 my-1' style={{textOverflow:"ellipsis"}} title={loginData.vUserName}>User: {loginData.vUserName}</p></div>
            <ul className="nav-list my-0 mt-1">
                {InputHTML}
            </ul>
            <ul className="nav-list my-0 overflow-auto mt-1" style={{maxHeight: "79vh"}} id="sidebarList">
                
                {listofCallCenterActionsHTML && listofCallCenterActionsHTML.length > 0 ?
                    <ul className="nav-list" aria-expanded={false} id="callcenterActionsList">
                        <li className='my-0 d-flex' style={{cursor: "pointer"}} onClick={() => {
                            handleReSizeMenu("callcenter")
                        }}>
                            <a title={"Call Center Actions List"}>
                                <Icon icon={'bx:support'} style={{color: "orange"}}/>
                                <span className="links_name fw-bold">{"Call Center"}</span>

                            </a>
                            {callCenterActionsArrowHTML}
                            <span className="tooltip">{"Call Center"}</span>
                        </li>
                        <ul className="nav-list my-0" ref={callCenterActionsRef}>
                            {listofCallCenterActionsHTML}
                        </ul>
                    </ul> 
                : ""}
                {listofTripActionsHTML && listofTripActionsHTML.length > 0 ?
                    <ul className="nav-list my-0" aria-expanded={false} id="tripActionsList">

                        <li className='my-0 d-flex' style={{cursor:"pointer"}} onClick={()=>{handleReSizeMenu("trip")}}>
                            <a title={"Trip Actions List"}>
                                <Icon icon={'bx:desktop'} style={{color:"orange"}}/>
                                <span className="links_name fw-bold">{"Trip Actions"}</span>
                                
                            </a>
                            {tripActionsArrowHTML}
                            <span className="tooltip">{"Trip Actions"}</span>
                        </li>
                        <ul className="nav-list my-0" ref={tripActionsRef}>
                            {listofTripActionsHTML}
                        </ul>
                    </ul>
                : ""}
                {listofDriverActionsHTML && listofDriverActionsHTML.length > 0 ?
                    <ul className="nav-list my-0" id="driverActionsList">
                        <li className='my-0 d-flex' style={{cursor: "pointer"}} onClick={() => {
                            handleReSizeMenu("driver")
                        }}>
                            <a title={"Driver Actions List"}>
                                <Icon icon={'bx:taxi'} style={{color: "orange"}}/>
                                <span className="links_name fw-bold">{"Driver Actions"}</span>

                            </a>
                            {driverActionsArrowHTML}
                            <span className="tooltip">{"Driver Actions"}</span>
                        </li>
                        <ul className="nav-list my-0" ref={driverActionsRef}>
                            {listofDriverActionsHTML}
                        </ul>
                    </ul>
                :""}
                {listofBrokerActionsHTML && listofBrokerActionsHTML.length > 0 ?
                    <ul className="nav-list my-0" id="brokerActionsList">
                        <li className='my-0 d-flex' style={{cursor: "pointer"}} onClick={() => {
                            handleReSizeMenu("broker")
                        }}>
                            <a title={"Broker Actions List"}>
                                <Icon icon={'bx:group'} style={{color: "orange"}}/>
                                <span className="links_name fw-bold">{"Broker Actions"}</span>

                            </a>
                            {brokerActionsArrowHTML}
                            <span className="tooltip">{"Broker Actions"}</span>
                        </li>
                        <ul className="nav-list my-0" ref={brokerActionsRef}>
                            {listofBrokerActionsHTML}
                        </ul>
                    </ul>
                :""}
                {listofRouteActionsHTML && listofRouteActionsHTML.length > 0 ?
                    <ul className="nav-list my-0" id="routeActionsList">
                        <li className='my-0 d-flex' style={{cursor: "pointer"}} onClick={() => {
                            handleReSizeMenu("route")
                        }}>
                            <a title={"Route Actions List"}>
                                <Icon icon={'bx:trip'} style={{color: "orange"}}/>
                                <span className="links_name fw-bold">{"Route Actions"}</span>

                            </a>
                            {routeActionsArrowHTML}
                            <span className="tooltip">{"Route Actions"}</span>
                        </li>
                        <ul className="nav-list my-0" ref={routeActionsRef}>
                            {listofRouteActionsHTML}
                        </ul>
                    </ul>
                :""}
                {listOfReportsHTML && listOfReportsHTML.length > 0 ? 
                    <ul className="nav-list my-0" id="reportsList">
                        <li className='my-0 d-flex' style={{cursor: "pointer"}} onClick={() => {
                            handleReSizeMenu("Reports")
                        }}>
                            <a title={"Reports"}>
                                <Icon icon={'mdi:file-chart'} style={{color: "orange"}} />
                                <span className="links_name fw-bold">{"Reports"}</span>
                            </a>
                            {reportsArrowHTML}
                            <span className="tooltip">{"Reports"}</span>
                        </li>
                        <ul className="nav-list my-0" ref={reportsActionsRef}>
                            {listOfReportsHTML}
                        </ul>
                    </ul>
                : ""}
                {listOfAdminSetupActionsHTML && listOfAdminSetupActionsHTML.length > 0 ?
                    <ul className="nav-list my-0" id="adminSetupActionsList">
                        <li className='my-0 d-flex' style={{cursor: "pointer"}} onClick={() => {
                            handleReSizeMenu("Admin")
                        }}>
                            <a title={"Admin & Setup"}>
                                <Icon icon={'mdi:account-cog'} style={{color: "orange"}}/>
                                <span className="links_name fw-bold">{"Admin & Setup"}</span>
                            </a>
                            {adminSetupActionsArrowHTML}
                            <span className="tooltip">{"Admin & Setup"}</span>
                        </li>
                        <ul className="nav-list my-0" ref={adminSetupActionsRef}>
                            {listOfAdminSetupActionsHTML}
                        </ul>
                    </ul>
                :""}
                {listofMTDiagnosticHTML && listofMTDiagnosticHTML.length > 0 ?
                    <ul className="nav-list my-0" id="mTDiagnosticList">
                        <li className='my-0 d-flex' style={{cursor: "pointer"}} onClick={() => {
                            handleReSizeMenu("mtdiagnostic")
                        }}>
                            <a title={"Microtransit Diagnostic List"}>
                                <Icon icon={'bx:file-find'} style={{color: "orange"}}/>
                                <span className="links_name fw-bold">{"MT Diagnostic"}</span>

                            </a>
                            {mtDiagnosticArrowHTML}
                            <span className="tooltip">{"MicroTransit Diagnostic"}</span>
                        </li>
                        <ul className="nav-list my-0" ref={mtDiagnosticRef}>
                            {listofMTDiagnosticHTML}
                        </ul>
                    </ul>
                :""}
                {listofStandingOrderHTML && listofStandingOrderHTML.length > 0 ?
                    <ul className="nav-list my-0">
                        <li className='my-0 d-flex' style={{cursor: "pointer"}} onClick={() => {
                            handleReSizeMenu("standingOrder")
                        }}>
                            <a title={"Standing Order List"}>
                                <Icon icon={'bxs:calendar'} style={{color: "orange"}}/>
                                <span className="links_name fw-bold">{"Standing Order"}</span>

                            </a>
                            {standingOrderArrowHTML}
                            <span className="tooltip">{"Standing Order"}</span>
                        </li>
                        <ul className="nav-list my-0" ref={standingOrderRef}>
                            {listofStandingOrderHTML}
                        </ul>
                    </ul>
                :""}
                {listofCompletedQueueHTML && listofCompletedQueueHTML.length > 0 ?
                    <ul className="nav-list my-0">
                        <li className='my-0 d-flex' style={{cursor: "pointer"}} onClick={() => {
                            handleReSizeMenu("completedQueue")
                        }}>
                            <a title={"Completed Queue List"}>
                                <Icon icon={'bxs:calendar'} style={{color: "orange"}}/>
                                <span className="links_name fw-bold">{"Completed Queue"}</span>
                            </a>
                            {completedQueueArrowHTML}
                            <span className="tooltip">{"Completed Queue"}</span>
                        </li>
                        <ul className="nav-list my-0" ref={standingOrderRef}>
                            {listofCompletedQueueHTML}
                        </ul>
                    </ul>
                :""}
            </ul>
            <ul className="nav-list my-0">
                {SignOut}
            </ul>
        </nav>
    );
};

export default MenuSideBar;